import React from 'react'
import { useState } from 'react';

function GovernanceFaq() {
  const [openIndex, setOpenIndex] = useState(0); // first item open by default

  const faqs = [
  {
    question: "What features are included in the governance plan?",
    answer: "Closecarbon's Governance plan offers essential tools for monitoring carbon emissions, setting reduction goals, and accessing basic verification services. Users can track their carbon footprint in real-time, receive customizable reports, and access a simplified verification process.",
  },
  {
    question: "How accurate is the carbon tracking feature in the governance plan?",
    answer: "Closecarbon's Governance plan offers essential tools for monitoring carbon emissions, setting reduction goals, and accessing basic verification services. Users can track their carbon footprint in real-time, receive customizable reports, and access a simplified verification process.",
  },
  {
    question: "How does the Governance plan differ from the Basic plan?",
    answer: "The Governance plan includes all features in the Basic plan, such as verification, validation, and carbon credits. Additionally, it offers real-time tracking of Nationally Determined Contributions (NDC) values which helps manage sustainability goals transparently and effectively.",
  },
  {
    question: "Is there a limit to the number of emissions I can track with the governance plan?",
    answer: "Yes. The Governance Plan allows you to track emission for single- facility while also getting access to the Nationally Determined Contributions (NDCs) of multiple facilities if your organization is a body that is assigned for such information.",
  },
  {
    question: "How can I cancel my governance plan subscription?",
    answer: "The Governance plan includes all features in the Basic plan, such as verification, validation, and carbon credits. Additionally, it offers real-time tracking of Nationally Determined Contributions (NDC) values which helps manage sustainability goals transparently and effectively.",
  },
];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full max-w-[758px] mx-auto flex flex-col items-center gap-8 py-12 mt-20 md:mt-40 mb-20 md:mb-60 px-4">
      <h2 className="font-medium text-[32px] md:text-[48px] leading-[100%] tracking-[-0.04em] text-[#141414] text-center">
        Frequently Asked <span className="text-[#0D924F]">Questions</span>
      </h2>

      <div className="w-full flex flex-col gap-6">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              className={`w-full bg-white rounded-xl transition-all duration-300 ease-in-out p-5 md:p-[25px] ${
                isOpen
                  ? "border-[0.8px] border-[rgba(13,146,79,0.3)]"
                  : "border border-[rgba(13,146,79,0.3)]"
              }`}
            >
              {/* Header row (icon + question + chevron) */}
              <div className="flex items-start md:items-center gap-[20px] w-full">
                {/* Icon */}
                <div className="w-10 h-10 flex-shrink-0 relative">
                  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5 0C22.1413 0 26.5925 1.84374 29.8744 5.12563C33.1563 8.40752 35 12.8587 35 17.5C35 22.1413 33.1563 26.5925 29.8744 29.8744C26.5925 33.1563 22.1413 35 17.5 35C12.8587 35 8.40752 33.1563 5.12563 29.8744C1.84374 26.5925 0 22.1413 0 17.5C0 12.8587 1.84374 8.40752 5.12563 5.12563C8.40752 1.84374 12.8587 0 17.5 0ZM18.4258 7.48047C16.3971 7.48047 14.793 8.05729 13.6133 9.21094C12.4023 10.3672 11.8281 11.9609 11.8281 13.9961H14.9609C14.9609 12.8438 15.1836 11.9336 15.6484 11.3008C16.1719 10.5312 17.0234 10.1758 18.2344 10.1758C19.1771 10.1706 19.9102 10.4271 20.4336 10.9453C20.9614 11.5316 21.2378 12.3017 21.2031 13.0898C21.1937 13.808 20.9308 14.4998 20.4609 15.043L20.1328 15.4258C18.3438 17.0234 17.2734 18.1758 16.9141 18.9219C16.5312 19.6641 16.3672 20.5703 16.3672 21.6172V22H19.5273V21.6133C19.5273 20.9531 19.6641 20.3789 19.9414 19.8281C19.2076 19.2984 19.5814 18.83 20.0391 18.4531C21.3594 17.2969 22.1562 16.5547 22.4062 16.2812C23.0664 15.3984 23.4219 14.2734 23.4219 12.8984C23.4219 11.2214 22.8724 9.90104 21.7734 8.9375C20.6719 7.94922 19.2148 7.48047 17.4258 7.48047ZM16.9336 23.3477C16.656 23.3398 16.3795 23.3868 16.1201 23.486C15.8607 23.5852 15.6234 23.7346 15.4219 23.9258C15.2196 24.1147 15.0608 24.3453 14.9563 24.6015C14.8517 24.8578 14.804 25.1337 14.8164 25.4102C14.8164 26.0156 15.0078 26.5117 15.4219 26.8945C15.8258 27.286 16.3672 27.5033 16.9297 27.5C17.5352 27.5 18.0273 27.3047 18.4414 26.9219C18.6461 26.7277 18.8081 26.4929 18.917 26.2327C19.026 25.9724 19.0795 25.6923 19.0742 25.4102C19.0793 25.1346 19.0282 24.8609 18.9241 24.6057C18.82 24.3505 18.6651 24.1192 18.4688 23.9258C18.0504 23.5403 17.4984 23.3329 16.9297 23.3477" fill="#006633"/>
                  </svg>

                  {/* Hidden logo placeholder */}
                  <div className="absolute inset-0 opacity-0">
                    <img
                      src="https://placehold.co/40x40"
                      alt="logo"
                      className="w-full h-full"
                    />
                  </div>
                </div>

                {/* Question and chevron */}
                <div className="flex-1 flex justify-between items-center gap-4">
                  <h3 className="font-medium text-[18px] md:text-[24px] leading-[29px] text-[#141414]">
                    {faq.question}
                  </h3>
                  
                  {/* Chevron icon */}
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="focus:outline-none flex-shrink-0"
                    aria-label={isOpen ? "Collapse answer" : "Expand answer"}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className={`transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    >
                      <path
                        d="M5 7.5L10 12.5L15 7.5"
                        stroke="#898989"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Answer section (only visible when open) */}
              {isOpen && (
                <div className="mt-6 w-full flex items-start gap-[30px] pl-6">
                  {/* Vertical line */}
                  <div className="w-[1px] h-auto min-h-[40px] bg-[#898989]" />
                  
                  {/* Answer text */}
                  <p className="text-[14px] md:text-[16px] leading-[19px] text-[#898989] flex-1">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  )
}

export default GovernanceFaq